import React from "react";

import Icon from "core/ReusableIcons/Icon";
import Photo from "core/ReusableIcons/Photo";
import Api from "core/ReusableIcons/Api";
import { API_LANDING_PAGE } from "data/links";
const contactUs =
    "mailto:info@thenounproject.com?subject=Wanted to get in contact";

/* -------------------------------------------------------------------------- */
/*                                   CONSTANTS                                  */
/* -------------------------------------------------------------------------- */

export const SHOW_DESKTOP_TABLE_MIN_SCREEN_WIDTH = "60rem";
export const BEFORE_SHOW_DESKTOP_TABLE_MIN_SCREEN_WIDTH = "59.9375rem";

/* -------------------------------------------------------------------------- */
/*                                    HERO                                    */
/* -------------------------------------------------------------------------- */

export const heroCardData = [
    {
        title: "Icons",
        icon: Icon,
        description:
            "Over 5 million icons to communicate any idea, available as PNG or SVG. Purchases support contributing artists.",
        highlights: [
            [["Free Creative Commons licenses"], ["1a"]],
            [["Edit color and more with purchase"], ["1b"]],
            [["Subscribers get unlimited downloads"], ["1c"]]
        ],
        sectionId: "icons"
    },
    {
        title: "Photos",
        icon: Photo,
        description:
            "Professionally curated images that celebrate diversity. Purchases support contributing artists.",
        highlights: [
            [["Free Creative Commons licenses"], ["2a"]],
            [["Affordable royalty-free photos"], ["2b"]],
            [["High-res with limited commercial use"], ["2c"]]
        ],
        sectionId: "photos"
    },
    {
        title: "Icon API",
        icon: Api,
        description:
            "Access the entire icon collection via our REST API. Supports growth stage to enterprise clients.",
        highlights: [
            [["Get started with 5K free API calls/mo"], ["3a"]],
            [["Reliable and infinitely scalable"], ["3b"]],
            [["Pro plans for any size business"], ["3c"]]
        ],
        sectionId: "icon-api"
    }
];

/* -------------------------------------------------------------------------- */
/*                           ICON PLANS AND PRICING                           */
/* -------------------------------------------------------------------------- */

export const INDIVIDUAL_SUBSCRIPTION = "INDIVIDUAL_SUBSCRIPTION";
export const TEAM_SUBSCRIPTION = "TEAM_SUBSCRIPTION";

/* ---------------------------- TABLET AND MOBILE --------------------------- */

export const iconsPricingBasicTable = [
    ["More than 5 million icons", true],
    ["PNG and SVG formats", true],
    ["Use without attribution", false],
    ["Edit color, background, shape", false],
    ["Unlimited icon licenses", false],
    ["Adobe, Mac, Office, Google apps", false],
    ["Multiple custom favorites boards", false],
    ["Ad-Free site", false],
    ["Share icons across team", false],
    ["Consolidated billing", false]
];

export const iconsPricingProDownloadTable = [
    ["More than 5 million icons", true],
    ["PNG and SVG formats", true],
    ["Use without attribution", true],
    ["Edit color, background, shape", false],
    ["Unlimited icon licenses", false],
    ["Adobe, Mac, Office, Google apps", false],
    ["Multiple custom favorites boards", false],
    ["Ad-Free site", false],
    ["Share icons across team", false],
    ["Consolidated billing", false]
];

export const iconsPricingIndividualSubTable = [
    ["More than 5 million icons", true],
    ["PNG and SVG formats", true],
    ["Use without attribution", true],
    ["Edit color, background, shape", true],
    ["Unlimited icon licenses", true],
    ["Adobe, Mac, Office, Google apps", true],
    ["Multiple custom favorites boards", true],
    ["Ad-Free site", true],
    ["Share icons across team", false],
    ["Consolidated billing", false]
];

export const iconsPricingTeamSubTable = [
    ["More than 5 million icons", true],
    ["PNG and SVG formats", true],
    ["Use without attribution", true],
    ["Edit color, background, shape", true],
    ["Unlimited icon licenses", true],
    ["Adobe, Mac, Office, Google apps", true],
    ["Multiple custom favorites boards", true],
    ["Ad-Free site", true],
    ["Share icons across team", true],
    ["Consolidated billing", true]
];

/* --------------------------------- DESKTOP -------------------------------- */

export const iconsPricingTableHeadingIds = {
    basicIconDownload: "basic-icon-download",
    proIconDownload: "pro-icon-download",
    nounProIndividual: "noun-pro-individual",
    nounProTeam: "noun-pro-team",
    threeMill: "icons-three-mill",
    format: "icons-format",
    withouAttr: "icons-without-attr",
    edit: "icons-edit",
    unlimited: "icons-unlimited",
    apps: "icons-apps",
    favorites: "icons-favorites",
    adFree: "icons-add-free",
    shareTeam: "icons-share-team",
    consolBilling: "icons-consol-billing"
};

/* -------------------------------------------------------------------------- */
/*                               PHOTOS PRICING                               */
/* -------------------------------------------------------------------------- */

/* ---------------------------- TABLET AND MOBILE --------------------------- */

export const photosPricingBasicTable = [
    [".2 MP Resolution", true],
    ["Creative Commons (CC BY-NC-ND 2.0)", true],
    ["Worldwide, in-perpetuity", true],
    ["Print one project", true],
    ["Crop image", false],
    ["Use without attribution", false],
    ["Edit, build upon, make derivative", false],
    ["Limited commercial use", false]
];

export const photosPricingLargeTable = [
    ["5 MP Resolution", true],
    ["Royalty-Free Noncommercial License", true],
    ["Worldwide, in-perpetuity", true],
    ["Print up to 100 copies", true],
    ["Crop image", true],
    ["Use without attribution", true],
    ["Edit, build upon, make derivative", false],
    ["Limited commercial use", false]
];

export const photosPricingFullResTable = [
    ["10+ MP Resolution", true],
    ["Royalty-Free Limited Commercial License", true],
    ["Worldwide, in-perpetuity", true],
    ["Print up to 250,000 copies", true],
    ["Crop image", true],
    ["Use without attribution", true],
    ["Edit, build upon, make derivative", true],
    ["Limited commercial use", true]
];

/* --------------------------------- DESKTOP -------------------------------- */

export const photosPricingTableHeadingIds = {
    basic: "photos-basic",
    large: "photos-large",
    fullRes: "photos-full-res",
    licenseAndQuality: "photos-license-and-quality",
    usageSummary: "photos-usage-summary",
    resolution: "photos-resolution",
    license: "photos-license",
    worldwide: "photos-worldwide",
    printedMaterials: "photos-printed-materials",
    cropImage: "photos-crop-image",
    withoutAttribution: "photos-use-without-attribution",
    edit: "photos-edit",
    limitedCommercialUse: "photos-limited-commercial-use"
};

/* -------------------------------------------------------------------------- */
/*                                 API PRICING                                */
/* -------------------------------------------------------------------------- */

/* ------------------------------ OUR CUSTOMERS ----------------------------- */

import ApiCustomerSquarespaceLogo from "./images/ApiCustomerSquarespaceLogo";
import ApiCustomerMuralLogo from "./images/ApiCustomerMuralLogo";
import ApiCustomerTeespringLogo from "./images/ApiCustomerTeespringLogo";
import ApiCustomerAdobeLogo from "./images/ApiCustomerAdobeLogo";
import ApiCustomerInvisionLogo from "./images/ApiCustomerInvisionLogo";

const apiCustomerLogoIconComponents = {
    ApiCustomerSquarespaceLogo,
    ApiCustomerMuralLogo,
    ApiCustomerTeespringLogo,
    ApiCustomerAdobeLogo,
    ApiCustomerInvisionLogo
};

const apiCustomerLogos = [
    {
        icon: "ApiCustomerSquarespaceLogo",
        title: "Squarespace"
    },
    {
        icon: "ApiCustomerMuralLogo",
        title: "Mural"
    },
    {
        icon: "ApiCustomerTeespringLogo",
        title: "Teespring"
    },
    {
        icon: "ApiCustomerAdobeLogo",
        title: "Adobe"
    },
    {
        icon: "ApiCustomerInvisionLogo",
        title: "Invision"
    }
];

/* ------------------------------ API CARDS ----------------------------- */

const apiCards = [
    {
        icons: [<Api key="Api" size="xl" />],
        title: "Free Starter Plan",
        description: "Up to 5,000 calls per month",
        priceSubHeading: "",
        price: "0",
        priceDuration: "/month",
        buttons: [{ text: "Learn More", href: API_LANDING_PAGE }]
    },
    {
        icons: [
            <Api key="Api 1" size="xl" />,
            <Api key="Api 2" size="xl" />,
            <Api key="Api 3" size="xl" />
        ],
        title: "Icon API Pro",
        description: "5,000+ calls per month",
        priceSubHeading: "Starting at",
        price: "150",
        priceDuration: "/month",
        buttons: [{ text: "Contact Us", href: contactUs }]
    }
];

export { apiCustomerLogos, apiCustomerLogoIconComponents, apiCards };
